import cx from "classnames";
import styles from "./ConfiguratorThemes.module.scss";
import NoImage from "../../../assets/images/NoImage.png";
import { useState, useEffect } from "react";
import { ConfiguratorThemeOptions } from "./ConfiguratorThemeOptions";
import { profileData } from "../../../helpers/viewerHelper";
import { Accordion } from "react-bootstrap";
// import { redirectURL1 } from "../../../helpers/configuratorInfo1";
// import { redirectURL2 } from "../../../helpers/configuratorInfo2";
import { useParams } from "react-router-dom";

export const ConfiguratorThemesSidebar = ({
  scenePassed,
  allLabels,
  setNewLabels,
  setNewScene,
  allScenes,
  setLabel,
  localLayoutData,
  localProfileData,
  localSceneData,
  selectedLayoutData,
  selectedProfileData,
  selectedDripTrayStyle,
  openendLabel,
  selectProfile,
  selectLayout,
  localDipTrayStyle,
  selectDripTrayStyle,
  localBracketData,
  localEndCapData,
  localElbowData,
  selectedBracketData,
  selectedEndcapData,
  selectedElbowData,
  selectBracket,
  selectEndcap,
  selectElbow,
  setSelectedFinishType,
  selectedFinishType,
  setHobSpotLabel,
  setSelectedHubSpot,
  selectedHubSpot,
  loading,
  // setShowThumbnail = () => {},
  setZoom,
}) => {
  const { modelId } = useParams();
  const [showScreen, setShowScreen] = useState("list");
  const [selectedList, setSelectedList] = useState();
  const [listLabels, setListLabels] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null);

  useEffect(() => {
    if (allScenes?.length && allLabels?.length) {
      let allListLabels = ["layout", "profile"];
      allLabels.map((lb) => allListLabels.push(lb.name));
      allListLabels = allListLabels.filter(function (item, pos) {
        return allListLabels.indexOf(item) == pos;
      });
      setHobSpotLabel?.(allListLabels?.slice(2) || []);
      setListLabels(allListLabels);
    }
  }, [allScenes, allLabels]);

  useEffect(() => {
    if (selectedList && selectedList !== "layout") {
      setSelectedHubSpot?.(selectedList);
    }
  }, [selectedList]);

  useEffect(() => {
    if (selectedHubSpot !== activeAccordion) {
      setActiveAccordion(selectedHubSpot);
      setShowScreen("optionsList");
      setSelectedList(selectedHubSpot);
    }
  }, [selectedHubSpot]);

  const selectListOption = (str, id) => {
    setSelectedList(str);
    setShowScreen("optionsList");
    openendLabel(id);
    if (str === activeAccordion) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(str);
    }
  };

  const pressedBack = () => {
    setSelectedList(null);
    setShowScreen("list");
    openendLabel(null);
  };

  const getOptionImageAndText = (str, label) => {
    let option = {};
    if (allLabels?.length) {
      let currentLabel = allLabels.find(
        (previewLabel) => previewLabel.id === label.id
      );
      if (currentLabel.selectedTexture) {
        option = currentLabel.selectedTexture;
      } else if (currentLabel?.textures?.length) {
        option = currentLabel?.textures[0];
      }
    }
    if (str === "img") {
      return (
        <>
          {!option?.thumb && option?.color_code ? (
            <div className={styles.imgContainer}>
              <div
                style={{
                  background: option.color_code,
                  padding: 25,
                  marginRight: "0.85em",
                }}
              ></div>
            </div>
          ) : (
            <div className={styles.imgContainer}>
              <img
                src={option?.thumb}
                height={70}
                width={70}
                alt="dummy"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = NoImage;
                }}
              />
            </div>
          )}
        </>
      );
    } else {
      return (
        <div
          className={styles.subHead}
          style={{ fontSize: 12, textAlign: "left" }}
        >
          Selected: {option?.display_name}
        </div>
      );
    }
  };

  const handleImageShow = (key, data) => {
    const { thumb } = data || {};
    switch (key) {
      // case "Rectangle":
      //   return rectangle;
      default:
        return thumb || NoImage;
    }
  };

  // const getRedactionalURLList = () => {
  //   switch (modelId) {
  //     case "1":
  //     case "3": {
  //       return redirectURL1;
  //     }
  //     case "2": {
  //       return redirectURL2;
  //     }
  //     default: {
  //       return redirectURL1;
  //     }
  //   }
  // };

  // const openNewPage = () => {
  //   const finishLabel = allLabels?.find(
  //     ({ name }) => name?.toLowerCase() === "finish"
  //   );
  //   if (!allLabels?.length || !finishLabel) {
  //     return null;
  //   }
  //   const currentLabel = allLabels.find(
  //     (previewLabel) => previewLabel?.id === finishLabel?.id
  //   );
  //   const option =
  //     currentLabel?.selectedTexture ||
  //     (currentLabel?.textures?.length && currentLabel.textures[0]) ||
  //     {};
  //   const selectedURL = getRedactionalURLList()?.find(
  //     ({ name }) => name === option?.display_name
  //   )?.url;
  //   return selectedURL || null;
  // };

  // console.log(allLabels,"allLabels")

  return (
    <aside className={cx(styles.root, styles.previewContainer)}>
      <div className={cx("hidden-scroll")}>
        {/* <div className={styles.headSubHead}>
                    <div style={{ display: 'block !important' }}>
                        <div className={styles.heading}>
                            CUSTOMISE YOUR BAR RAIL
                        </div>
                        <div className={styles.subHead}>
                            Choose from the range of options
                        </div>
                    </div>
                </div> */}
        <Accordion activeKey={[activeAccordion,"layout", ...allLabels?.map(({name})=> name)]} alwaysOpen>
          {localProfileData?.length > 1 && (
            <Accordion.Item
              eventKey="profile"
              onClick={() => selectListOption("profile")}
            >
              <Accordion.Header>
                {localProfileData?.length > 1 && (
                  <div className={styles.labelOption}>
                    <div className={styles.imgContainer}>
                      <img
                        src={handleImageShow(selectedProfileData?.name, selectedProfileData)}
                        height={70}
                        width={70}
                        alt="dummy"
                      />
                    </div>
                    <div className={styles.textContainer}>
                      <div style={{ display: "block !important" }}>
                        <div
                          className={styles.heading}
                          style={{ fontSize: 11, textAlign: "left" }}
                        >
                          Room Style
                        </div>
                        <div
                          className={styles.subHead}
                          style={{ fontSize: 12 }}
                        >
                          {selectedProfileData?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Accordion.Header>
              <Accordion.Body>
                <div className={cx("hidden-scroll")}>
                  <ConfiguratorThemeOptions
                    selectedList={selectedList}
                    allLabels={allLabels}
                    allScenes={allScenes}
                    scenePassed={scenePassed}
                    pressedBackBtn={() => pressedBack()}
                    profileData={profileData}
                    selectedProfile={selectedProfileData}
                    setNewScene={(data) => setNewScene(data)}
                    setNewLabels={(data) => setNewLabels(data)}
                    listLabels={listLabels}
                    setNewList={(data) => setSelectedList(data)}
                    setLabel={setLabel}
                    localLayoutData={localLayoutData}
                    localProfileData={localProfileData}
                    selectedLayoutData={selectedLayoutData}
                    selectedProfileData={selectedProfileData}
                    selectedDripTrayStyle={selectedDripTrayStyle}
                    selectProfile={selectProfile}
                    selectDripTrayStyle={selectDripTrayStyle}
                    localBracketData={localBracketData}
                    localEndCapData={localEndCapData}
                    localElbowData={localElbowData}
                    selectedBracketData={selectedBracketData}
                    selectedEndcapData={selectedEndcapData}
                    selectedElbowData={selectedElbowData}
                    selectBracket={selectBracket}
                    selectEndcap={selectEndcap}
                    selectElbow={selectElbow}
                    selectLayout={selectLayout}
                    loading={loading}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {localLayoutData?.length > 1 && (
            <Accordion.Item
              eventKey="layout"
              className="no-arrow"
            >
              <Accordion.Header>
                {localLayoutData?.length > 1 && (
                  <div className={styles.labelOption}>
                    <div className={styles.textContainer}>
                      <div style={{ display: "block !important" }}>
                        <div
                          className={styles.heading}
                          style={{ fontSize: 11, textAlign: "left" }}
                        >
                          Size
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Accordion.Header>
              <Accordion.Body>
                <div className={cx("hidden-scroll")}>
                  <ConfiguratorThemeOptions
                    showSizeBtn={true}
                    selectedList={'layout'}
                    allLabels={allLabels}
                    allScenes={allScenes}
                    scenePassed={scenePassed}
                    pressedBackBtn={() => pressedBack()}
                    profileData={profileData}
                    selectedProfile={selectedProfileData}
                    setNewScene={(data) => setNewScene(data)}
                    setNewLabels={(data) => setNewLabels(data)}
                    listLabels={listLabels}
                    setNewList={(data) => setSelectedList(data)}
                    setLabel={setLabel}
                    localLayoutData={localLayoutData}
                    localProfileData={localProfileData}
                    selectedLayoutData={selectedLayoutData}
                    selectedProfileData={selectedProfileData}
                    selectedDripTrayStyle={selectedDripTrayStyle}
                    selectProfile={selectProfile}
                    selectDripTrayStyle={selectDripTrayStyle}
                    localBracketData={localBracketData}
                    localEndCapData={localEndCapData}
                    localElbowData={localElbowData}
                    selectedBracketData={selectedBracketData}
                    selectedEndcapData={selectedEndcapData}
                    selectedElbowData={selectedElbowData}
                    selectBracket={selectBracket}
                    selectEndcap={selectEndcap}
                    selectElbow={selectElbow}
                    selectLayout={selectLayout}
                    loading={loading}
                    setZoom={setZoom}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {localBracketData?.length > 0 && (
            <Accordion.Item
              eventKey="bracket"
              onClick={() => selectListOption("bracket")}
            >
              <Accordion.Header>
                {localBracketData?.length > 0 && (
                  <div className={styles.labelOption}>
                    <div className={styles.imgContainer}>
                      <img
                        src={handleImageShow(
                          selectedBracketData?.name,
                          selectedBracketData
                        )}
                        height={70}
                        width={70}
                        alt="dummy"
                      />
                    </div>
                    <div className={styles.textContainer}>
                      <div style={{ display: "block !important" }}>
                        <div
                          className={styles.heading}
                          style={{ fontSize: 11, textAlign: "left" }}
                        >
                          Bracket
                        </div>
                        <div
                          className={styles.subHead}
                          style={{ fontSize: 12 }}
                        >
                          {selectedBracketData?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Accordion.Header>
              <Accordion.Body>
                <div className={cx("hidden-scroll")}>
                  <ConfiguratorThemeOptions
                    selectedList={selectedList}
                    allLabels={allLabels}
                    allScenes={allScenes}
                    scenePassed={scenePassed}
                    pressedBackBtn={() => pressedBack()}
                    profileData={profileData}
                    selectedProfile={selectedProfileData}
                    setNewScene={(data) => setNewScene(data)}
                    setNewLabels={(data) => setNewLabels(data)}
                    listLabels={listLabels}
                    setNewList={(data) => setSelectedList(data)}
                    setLabel={setLabel}
                    localLayoutData={localLayoutData}
                    localProfileData={localProfileData}
                    selectedLayoutData={selectedLayoutData}
                    selectedProfileData={selectedProfileData}
                    selectedDripTrayStyle={selectedDripTrayStyle}
                    selectProfile={selectProfile}
                    selectDripTrayStyle={selectDripTrayStyle}
                    localBracketData={localBracketData}
                    localEndCapData={localEndCapData}
                    localElbowData={localElbowData}
                    selectedBracketData={selectedBracketData}
                    selectedEndcapData={selectedEndcapData}
                    selectedElbowData={selectedElbowData}
                    selectBracket={selectBracket}
                    selectEndcap={selectEndcap}
                    selectElbow={selectElbow}
                    loading={loading}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {localEndCapData?.length > 0 && (
            <Accordion.Item
              eventKey="endcap"
              onClick={() => selectListOption("endcap")}
            >
              <Accordion.Header>
                {localEndCapData?.length > 0 && (
                  <div className={styles.labelOption}>
                    <div className={styles.imgContainer}>
                      <img
                        src={handleImageShow(
                          selectedEndcapData?.name,
                          selectedEndcapData
                        )}
                        height={70}
                        width={70}
                        alt="dummy"
                      />
                    </div>
                    <div className={styles.textContainer}>
                      <div style={{ display: "block !important" }}>
                        <div
                          className={styles.heading}
                          style={{ fontSize: 11, textAlign: "left" }}
                        >
                          Endcap
                        </div>
                        <div
                          className={styles.subHead}
                          style={{ fontSize: 12 }}
                        >
                          {selectedEndcapData?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Accordion.Header>
              <Accordion.Body>
                <div className={cx("hidden-scroll")}>
                  <ConfiguratorThemeOptions
                    selectedList={selectedList}
                    allLabels={allLabels}
                    allScenes={allScenes}
                    scenePassed={scenePassed}
                    pressedBackBtn={() => pressedBack()}
                    profileData={profileData}
                    selectedProfile={selectedProfileData}
                    setNewScene={(data) => setNewScene(data)}
                    setNewLabels={(data) => setNewLabels(data)}
                    listLabels={listLabels}
                    setNewList={(data) => setSelectedList(data)}
                    setLabel={setLabel}
                    localLayoutData={localLayoutData}
                    localProfileData={localProfileData}
                    selectedLayoutData={selectedLayoutData}
                    selectedProfileData={selectedProfileData}
                    selectedDripTrayStyle={selectedDripTrayStyle}
                    selectProfile={selectProfile}
                    selectDripTrayStyle={selectDripTrayStyle}
                    localBracketData={localBracketData}
                    localEndCapData={localEndCapData}
                    localElbowData={localElbowData}
                    selectedBracketData={selectedBracketData}
                    selectedEndcapData={selectedEndcapData}
                    selectedElbowData={selectedElbowData}
                    selectBracket={selectBracket}
                    selectEndcap={selectEndcap}
                    selectElbow={selectElbow}
                    loading={loading}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {localElbowData?.length > 0 && (
            <Accordion.Item
              eventKey="elbow"
              onClick={() => selectListOption("elbow")}
            >
              <Accordion.Header>
                {localProfileData?.length > 0 && (
                  <div className={styles.labelOption}>
                    <div className={styles.imgContainer}>
                      <img
                        src={handleImageShow(
                          selectedElbowData?.name,
                          selectedElbowData
                        )}
                        height={70}
                        width={70}
                        alt="dummy"
                      />
                    </div>
                    <div className={styles.textContainer}>
                      <div style={{ display: "block !important" }}>
                        <div
                          className={styles.heading}
                          style={{ fontSize: 11, textAlign: "left" }}
                        >
                          Elbow
                        </div>
                        <div
                          className={styles.subHead}
                          style={{ fontSize: 12 }}
                        >
                          {selectedElbowData?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Accordion.Header>
              <Accordion.Body>
                <div className={cx("hidden-scroll")}>
                  <ConfiguratorThemeOptions
                    selectedList={selectedList}
                    allLabels={allLabels}
                    allScenes={allScenes}
                    scenePassed={scenePassed}
                    pressedBackBtn={() => pressedBack()}
                    profileData={profileData}
                    selectedProfile={selectedProfileData}
                    setNewScene={(data) => setNewScene(data)}
                    setNewLabels={(data) => setNewLabels(data)}
                    listLabels={listLabels}
                    setNewList={(data) => setSelectedList(data)}
                    setLabel={setLabel}
                    localLayoutData={localLayoutData}
                    localProfileData={localProfileData}
                    selectedLayoutData={selectedLayoutData}
                    selectedProfileData={selectedProfileData}
                    selectedDripTrayStyle={selectedDripTrayStyle}
                    selectProfile={selectProfile}
                    selectDripTrayStyle={selectDripTrayStyle}
                    localBracketData={localBracketData}
                    localEndCapData={localEndCapData}
                    localElbowData={localElbowData}
                    selectedBracketData={selectedBracketData}
                    selectedEndcapData={selectedEndcapData}
                    selectedElbowData={selectedElbowData}
                    selectBracket={selectBracket}
                    selectEndcap={selectEndcap}
                    selectElbow={selectElbow}
                    loading={loading}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}

          {localDipTrayStyle?.length > 0 && (
            <Accordion.Item
              eventKey="trayStyle"
              onClick={() => selectListOption("dripStyle")}
            >
              <Accordion.Header>
                {localDipTrayStyle?.length > 0 && (
                  <div className={styles.labelOption}>
                    <div className={styles.imgContainer}>
                      <img
                        src={handleImageShow(selectedDripTrayStyle?.name)}
                        height={70}
                        width={70}
                        alt="dummy"
                      />
                    </div>
                    <div className={styles.textContainer}>
                      <div style={{ display: "block !important" }}>
                        <div
                          className={styles.heading}
                          style={{ fontSize: 11, textAlign: "left" }}
                        >
                          Drip Tray Style
                        </div>
                        <div
                          className={styles.subHead}
                          style={{ fontSize: 12 }}
                        >
                          {selectedDripTrayStyle?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Accordion.Header>
              <Accordion.Body>
                <div className={cx("hidden-scroll")}>
                  <ConfiguratorThemeOptions
                    selectedList={selectedList}
                    allLabels={allLabels}
                    allScenes={allScenes}
                    scenePassed={scenePassed}
                    pressedBackBtn={() => pressedBack()}
                    profileData={profileData}
                    selectedProfile={selectedProfileData}
                    setNewScene={(data) => setNewScene(data)}
                    setNewLabels={(data) => setNewLabels(data)}
                    listLabels={listLabels}
                    setNewList={(data) => setSelectedList(data)}
                    setLabel={setLabel}
                    localLayoutData={localLayoutData}
                    localProfileData={localProfileData}
                    selectedLayoutData={selectedLayoutData}
                    selectedProfileData={selectedProfileData}
                    selectedDripTrayStyle={selectedDripTrayStyle}
                    selectProfile={selectProfile}
                    localDipTrayStyle={localDipTrayStyle}
                    selectDripTrayStyle={selectDripTrayStyle}
                    localBracketData={localBracketData}
                    localEndCapData={localEndCapData}
                    localElbowData={localElbowData}
                    selectedBracketData={selectedBracketData}
                    selectedEndcapData={selectedEndcapData}
                    selectedElbowData={selectedElbowData}
                    selectBracket={selectBracket}
                    selectEndcap={selectEndcap}
                    selectElbow={selectElbow}
                    loading={loading}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          )}
          {!!allLabels?.length &&
            allLabels.map((label, index) => {
              return (
                <Accordion.Item eventKey={label.name} key={label.name} className="no-arrow">
                  <Accordion.Header
                    // onClick={() => selectListOption(label.name, label.id)}
                  >
                    <div className={styles.labelOption} key={index}>
                      {/* {getOptionImageAndText("img", label)} */}
                      <div className={styles.textContainer}>
                        <div style={{ display: "block !important" }}>
                          <div
                            className={styles.heading}
                            style={{
                              fontSize: 11,
                              textAlign: "left",
                              textWrap: "wrap",
                            }}
                          >
                            {label.name}
                          </div>
                          {getOptionImageAndText("text", label)}
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className={cx("hidden-scroll")}>
                      <ConfiguratorThemeOptions
                        // selectedList={selectedList}
                        selectedList={label.name}
                        showSubLabel={label.name === "Upholstery"}
                        // setShowThumbnail={label.name === "Upholstery" ? setShowThumbnail : () => {}}
                        allLabels={allLabels}
                        allScenes={allScenes}
                        scenePassed={scenePassed}
                        pressedBackBtn={() => pressedBack()}
                        profileData={profileData}
                        selectedProfile={selectedProfileData}
                        setNewScene={(data) => setNewScene(data)}
                        setNewLabels={(data) => setNewLabels(data)}
                        listLabels={listLabels}
                        setNewList={(data) => setSelectedList(data)}
                        setLabel={setLabel}
                        localLayoutData={localLayoutData}
                        localProfileData={localProfileData}
                        selectedLayoutData={selectedLayoutData}
                        selectedProfileData={selectedProfileData}
                        selectedDripTrayStyle={selectedDripTrayStyle}
                        selectProfile={selectProfile}
                        selectDripTrayStyle={selectDripTrayStyle}
                        localBracketData={localBracketData}
                        localEndCapData={localEndCapData}
                        localElbowData={localElbowData}
                        selectedBracketData={selectedBracketData}
                        selectedEndcapData={selectedEndcapData}
                        selectedElbowData={selectedElbowData}
                        selectBracket={selectBracket}
                        selectEndcap={selectEndcap}
                        selectElbow={selectElbow}
                        selectedFinishType={selectedFinishType}
                        setSelectedFinishType={setSelectedFinishType}
                        loading={loading}
                        setZoom={setZoom}
                      />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
        </Accordion>
      </div>
      {/* {openNewPage() && (
        <div className={styles.shopBtn}>
          <button>
            <a href={openNewPage()} target="_blank">
              SHOP THIS PRODUCT
            </a>
          </button>
        </div>
      )} */}
    </aside>
  );
};
